// @flow strict
/* eslint jsx-a11y/click-events-have-key-events: off */
/* eslint jsx-a11y/no-static-element-interactions: off */
import * as React from 'react';
import classnames from 'classnames';
// eslint-disable-next-line css-modules/no-unused-class
import styles from '../styles.scss';

type WrapperPropsType = {
  onClick?: () => void,
  isDisabled?: boolean,
  children: React.Node,
  className?: string,
};
const Wrapper = (props: WrapperPropsType) => {
  const classes = classnames(
    styles.wrapper,
    props.isDisabled && styles.isDisabled,
    props.className,
  );
  return (
    <span className={classes} onClick={props.onClick}>
      {props.children}
    </span>
  );
};

export default Wrapper;
